import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { AccountContext } from "views/AccountWrapper";
import { hasSpaceManageAccess } from "utils/user";
import { hasManageAccess } from "utils/access";
import { SpaceAccessLevel } from "types/generated";

const useCanManageSpace = (spaceId?: string, spaceAccessLevel?: SpaceAccessLevel) => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useTypedFlags();

  if (!spaceId) {
    return false;
  }

  if (customAccessRoles) {
    return hasManageAccess(viewer, spaceId);
  }

  if (!spaceAccessLevel) {
    return false;
  }

  return viewer.admin || hasSpaceManageAccess(spaceAccessLevel);
};

export default useCanManageSpace;
